import React from 'react'
import { Typography, useTheme } from '@mui/material'

export const PhoneDisclaimer: React.FC = () => {
  const theme = useTheme()
  return (
    <div
      style={{
        paddingLeft: '10px',
        paddingRight: '10px'
      }}
    >
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        Your phone number may be used for customer communications, fraud
        prevention, and two-factor authentication. Standard carrier SMS fees may
        apply.
      </Typography>
      <Typography component="p" variant="caption" sx={{ mb: theme.spacing(1) }}>
        <b>IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT:</b>{' '}
        To help the government fight the funding of terrorism and money
        laundering activities, Federal law requires all financial institutions
        to obtain, verify and record information that identifies each person who
        opens an account. What this means for you: When you open an account, we
        will ask for your name, address, date of birth and other information
        that will allow us to identify you. We may also ask to see your driver's
        license or other identifying documents.
      </Typography>
    </div>
  )
}
